import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { HorseName } from '../../utils/racing-game/consts.ts';
import { StableName } from '../../utils/racing-game/horses.ts';

type LastSingleBet = {
  name: HorseName;
  amount: number;
};

type LastStableBet = {
  name: StableName;
  amount: number;
};

type LastBetStore = {
  lastSingleBet: Nullish<LastSingleBet>;
  lastStableBet: Nullish<LastStableBet>;
  setLastSingleBet: (bet: LastSingleBet) => void;
  setLastStableBet: (bet: LastStableBet) => void;
};

export const useLastBetStore = create<LastBetStore>()(
  immer((set) => ({
    lastSingleBet: null,
    lastStableBet: null,
    setLastSingleBet: (bet) =>
      set((state) => {
        state.lastSingleBet = bet;
      }),
    setLastStableBet: (bet) =>
      set((state) => {
        state.lastStableBet = bet;
      }),
  }))
);
